export default {
	Slide: 'Puzzle',
	Puzzle: 'Puzzle',
	'The puzzle is open!': 'Puzzle je otevřený!',
	'Congratulations!': ' Gratulujeme!',
	'You get it': 'ty dostaneš',
	'You get the task done': 'Úkol je splněn ty dostaneš',

	'Show all blocked': 'Zobrazit všechny zablokované',

	Blocked: 'Blokováno',
	Unlocked: 'Odemčený',

	Author: 'Autor',
	'Reset filters': 'Resetovat filtry',

	'Block student': 'Blokovat studenta',

	Change: 'Změna',
	'The student is blocked': 'Student je zablokován',
	'The student is blocked with a new price':
		'Student je zablokován s novou cenou',
	'To unlock this student, go to the "Restore" section':
		'Chcete-li tohoto studenta odemknout, přejděte do sekce Obnovení',

	'Before blocking, you can change the price for the student':
		'Před zablokováním můžete změnit cenu pro studenta',

	'First month cost': 'Cena za 1 měsíc',

	'WARNING! After re-saving the task, the students who completed this task will have the puzzle closed and will have to do it again.':
		'POZOR!Po opětovném uložení úkolu budou mít žáci, kteří tento úkol splnili, hádanku uzavřenou a budou ji muset opakovat.',

	"You cannot do homework in the student's platform":
		'Domácí úkol nelze vykonat na žákovské platformě',

	'Restore the student ?': 'Obnovit žáka?',
	'Restore the teacher ?': 'Obnovit učitele?',
	'Restore the franchise ?': 'Obnovit franšízanta?',

	Faces: 'Tvář',

	Heroes: 'Hrdinové',
	Clothes: 'Oblečení',
	Backgrounds: 'Pozadí',
	Souvenirs: 'Suvenýry',

	'Coming soon': 'Brzy',

	'Wow! Congratulations, you have successfully purchased this product.':
		'Wow! Gratulujeme, úspěšně jste zakoupil tento produkt.',
	'You can view all your purchases in the "Purchased" section':
		'Všechny své nákupy si můžeš prohlédnout v sekci „Zakoupeno“"',

	'Your savings': 'tvoje úspory',
	'You can spend them on something interesting!':
		'Můžeš je utratit za něco zajímavého цікаве!',

	'A student with this email address already exists':
		'žak s touto e-mailovou adresou již existuje',

	'User with such email already exists':
		'Uživatel s touto e-mailovou adresou již existuje',
	'Year of birth': 'Rok narození',
	Registration: 'Registrace',
	'Surname of parents': 'Příjmení rodičů',
	School: 'škola',
	'Field is required': 'Toto pole je nutné',
	'Select age': 'Vyberte věk',
	'No such teacher for this year': 'Letos žádný takový učitel není',
	'User with such phone number already exists':
		'Uživatel s tímto telefonním číslem již existuje',
	'You are successfully registered': 'Jste úspěšně zaregistrováni',
	'Max length 20 chars': 'Maximální délka je 20 znaků',
	'INTERNATIONAL SCHOOL': 'MEZINÁRODNÍ ŠKOLA',
	'Mental Arithmetic': 'Mentální aritmetika',
	'For children aged 5-14.': 'Pro děti 5-14 let.',
	'Sign up for a trial lesson': 'Přihlaste se na zkušební hodinu',
	'Parents name': 'Jméno rodičů',
	'Childs age': 'Věk dítěte',
	Country: 'Země',
	'Sign up': 'Přihlásit se',
	'Open offer agreement': 'Otevřená nabídková smlouva',
	'Participate in online Indigo Olympiad':
		'Soutěž se v online olympiádě Indigo',
	Participate: 'Zúčastnit se',
	export: ' Export',
	wrong: 'Nesprávně',
	right: 'správně',
	match: {
		addition: 'rychlé a zběsilé',
		multiply: 'Násobení',
		divide: 'Dělení',
		abacus_random: 'Abacus náhodný',
		anzan: 'Anzan',
		negative: 'Záporná čísla',
		column: 'Sloupce',
	},
	timeIsOver: 'Čas vypršel',
	timer: 'Časovač',
	'Back to Lessons': 'Zpět na seznam lekcí',
	'Create Lesson': ' Vytvořit lekci',
	Home: 'Na hlavní',
	Assign: 'Přidělit',
	'To cabinet': 'Do kabinetu',
	'Create a homework': 'Vytvořit domácí úkol',
	January: 'leden',
	February: 'únor',
	March: 'březen',
	April: 'Duben',
	May: 'Květen',
	June: 'Červen',
	July: 'Červenec',
	August: 'srpen',
	'Group nickname': 'Přezdívka skupiny',
	September: 'září',
	October: 'říjen',
	November: 'Listopad',
	December: 'prosinec',
	Overall: 'Obecně',
	Active: ' Aktivní',
	'Contract number': 'číslo smlouvy',
	'For parents': 'Pro rodiče',
	'Choose lessons': 'Vyberte lekce',
	Save: 'přiřadit',
	Close: 'Zavřít',
	'Change birthday': 'změna datumu narozeni',
	Sent: 'Odesláno',
	'Include students': 'Zapojit žáky',
	'Add service': 'Přidat službu',
	'Create folder': 'Vytvořit složku',
	Answer: ' odpověď ',
	Price: ' Cena ',
	'Date of creating': 'Datum vzniku',
	Month: ' Měsíc ',
	unpaid: 'Nezaplaceno',
	paid: 'Zaplaceno',
	'Excluded students': 'Vyloučení žáky',
	'Selected groups': 'Vybrané skupiny',
	Monday: ' Pondělí',
	Tuesday: ' Úterý',
	Wensday: ' Středa',
	Thusday: ' čtvrtek',
	Friday: 'pátek',
	Saturday: 'sobota',
	Sunday: ' Neděle',
	Mo: 'Po',
	Tu: 'út',
	We: 'St',
	Th: 'Čt',
	Fr: 'Pá',
	Sa: 'So',
	Su: 'Ne',
	End: 'Konec',
	'Add discount': 'Přidat slevu',
	Edit: 'Upravit',
	'Parent found': 'Otec nalezen',
	'Changes saved': ' uloženo ',
	'The passwords of the parent and the student should not coincide':
		'Hesla rodičů a žáku nemají být stejně',
	'Your region`s price is set to': 'Cena vašeho regionu je nastavena jako',
	'and the holder`s reward is': 'a odměna držitele práv je',
	'regardless of the set price': 'bez ohledu na nastavenou cenu',
	'The given password is not unique for this email':
		'Toto heslo není jedinečné pro tuto e-mailovou adresu',
	'Enter a valid email address.': 'Prosím zadejte platnou emailovou adresu.',
	'The phone number entered is not valid': 'Zadané telefonní číslo neexistuje',
	Holiday: ' Prázdniny ',
	'Working days': 'Pracovní dny',
	Street: 'Ulice',
	'Location name': 'název polohy',
	District: 'Okres',
	'Field required': ' Pole je povinné ',
	'Type of legal activity': 'Typ právní činnosti',
	'Legal address': 'sídlo',
	'Registration number': 'Evidenční číslo',
	'Add Group': 'Přidat skupinu',
	'Add Student': 'Přidat žáka ',
	Signin: 'přihlásit se',
	'Bonus days': 'Bonusové dny',
	'Bonus weeks': 'Bonusové týdny',
	'Are you sure you want to delete?': 'Jste si jistí, že to chcete smazat?',
	Delete: ' smazat ',
	Days: ' dnů ',
	Confirm: 'Potvrdit',
	Cancel: 'Zrušit',
	Week: ' Týden ',
	Weeks: 'Týdní ',
	'Group age name': 'jméno věkové skupiny',
	'Set bonus days': 'Nastavit bonusové dny',
	'Default language': 'Výchozí jazyk',
	'With english': 'S angličtinou',
	'Without english': 'Žádná angličtina',
	'Paid status': 'Stav platby',
	'Not paid': 'Nezaplaceno',
	Turnover: 'obrat',
	Block: 'Blokovat',
	Blocked: ' Zablokováno ',
	'On holidays': 'Na prázdninách',
	Language: 'Jazyk',
	Discounts: 'slevy',
	Message: 'Zpráva',
	Subject: 'Téma',
	Homework: ' Domácí úkol',
	'Homework ': 'Školení',
	'Homework on': 'domácí úkol na',
	'Sum Sub': 'rychle a zběsile',
	'You need to complete the exercises': 'Musíte splnit zadáni',
	Homework: 'Domácí úkoly',
	'Invoice for': 'Faktura za',
	'PJSC CB "PRIVATBANK" in Kyiv': 'ПАТ КБ "ПРИВАТБАНК" м. Київа',
	Account: ' Účet ',
	Supplier: ' Dodavatel ',
	Buyer: ' Kupující ',
	'Bank code': 'bankovní kód',
	'Type phone number or email':
		'Zadejte telefonní číslo nebo e-mailovou adresu',
	'Type password': 'Zadejte heslo',
	'Forgot password': 'Zapomněli jste heslo',
	'Type your email': 'Zadejte svou e-mailovou adresu',
	Send: 'Poslat',
	'Email sent': 'Email odeslán',
	'If you are signed up for the project you will receive email with the next instructions to get back access your account':
		'Pokud jste přihlášeni do projektu, obdržíte e- mail s dalšími pokyny, jak získat zpět přístup ke svému účtu',
	'Back to the sign in': 'Zpět na přihlášení',
	'Password or login is not correct':
		'Heslo nebo přihlašovací jméno jsou nesprávné',
	'Password recovery': 'Obnova hesla',
	'Type your new password here': 'Zadejte své nové heslo',
	'Set new password': 'Nastavit nové heslo',
	'Learn more': 'Zjistit více',
	'About Us': 'O nás',
	Company: ' Společnost',
	Jobs: ' Práce ',
	Press: ' noviny ',
	'Terms of Use': 'Podmínky použití',
	'Privacy Policy': 'Zásady ochrany osobních údajů',
	'Need help?': 'Potřebujete pomoc?',
	'Contact us': 'Kontaktujte nás',
	'Become franchise': 'Staňte se franšízantem',
	'Select language': 'Vyberte jazyk',
	English: 'Angličtina',
	Russian: 'Ruština',
	Azerbaijani: 'Ázerbájdžánština',
	Ukrainian: 'Ukrajinština',
	Polish: 'Polština',
	//'čeština',
	'Mental arithmetic is an oral account technique that rapidly develops the intellectual ability and intelligence of a child between 5 and 14 years of age. The training process takes place on special Japanese accountants Abaсus (Soroban). Mental arithmetic trains simultaneously the left and right hemispheres of the brain, improving visual memory, concentration of attention, creative orientation, imaginative thinking of children and their tendency to fast reading.':
		'Mentální aritmetika je metoda ústního počítání, která rychle rozvíjí mentální schopnosti a inteligenci dětí ve věku 5 až 14 let. Proces učení probíhá na speciálních japonských výpočtech Abacus (Soroban). Mentální aritmetika současně trénuje levou a pravou hemisféru mozku, zlepšení zrakové paměti, koncentrace pozornosti, kreativní orientace, nápadité myšlení dětí a jejich sklon k rychlému čtení.',
	Management: ' Řízení ',
	'Master Franchise': 'Mistr Franchisant',
	Franchise: 'franšízant',
	Teachers: ' Učitelé ',
	Groups: ' Skupiny ',
	Students: ' Žáci ',
	Student: 'Žák',
	Parents: ' Rodiče ',
	Profile: ' Profil ',
	'My profile': 'Můj profil',
	Finance: ' Finance ',
	Reports: ' Zprávy ',
	Report: 'Zpráva',
	Upload: ' Přidat',
	List: 'Seznam',
	Payments: ' Platby ',
	Documents: 'Scan copyii',
	Lessons: 'Lekce',
	Materials: 'materiály',
	Shop: 'Obchod',
	Statistics: 'Statistika',
	Settings: 'Nastavení',
	Pages: 'stránky',
	Logout: ' Odhlásit se ',
	Dashboard: 'Osobní kancelář',
	'Access denied': 'Přístup zamítnut',
	Create: 'Vytvořit',
	Download: 'Stáhnout',
	Status: 'Status',
	'Payment Date': 'Datum platby',
	'Payment Amount': 'Částka k úhradě',
	'Start time': 'čas zahájení lekce',
	'Group age': 'Věková skupina',
	Junior: 'Juniorský',
	Average: ' Průměrný ',
	Class: ' Třída ',
	Older: ' Starší ',
	Region: ' Kraj ',
	Group: 'Skupina',
	Person: 'Osoba',
	Finances: 'Finance',
	Actions: 'Akce',
	'Choose date': 'Vyberte datum',
	'Send invoice': 'Faktura',
	'Download invoice': 'Stáhnout fakturu',
	'Send email': 'Poslat e-mail',
	'Create Student': 'Vytvořit žaka',
	'The beginning of holidays': 'Začátek prázdnin',
	'Start of study': 'Začátek studia',
	'Group name': ' jméno skupiny ',
	'Group address': 'adresa skupiny',
	'Group teacher': 'učitel skupiny',
	'Group students': 'Žáci skupiny',
	'Group statistics': 'Statistika skupiny',
	Tasks: 'Úkoly',
	'Only task': 'Úkol',
	'Current task': 'Aktuální úkol',
	'Next tasks': 'Další úkoly',
	Search: 'Vyhledávání',
	'General information': 'Obecná informace',
	'Phone number': 'Telefonní číslo',
	'First name': 'jméno',
	Surname: 'По-батьковi',
	'Last name': 'Příjmení',
	'Date of birth': 'Datum narození',
	Password: 'Heslo',
	'Additional information': 'Dodatečné informace',
	'Id code': 'Id code',
	Passport: 'Pas',
	'With email newsletter': 'S e-mailovým zpravodajem',
	'Without email newsletter': 'Bez e-mailového zpravodaje',
	'Financial information': 'finanční informace',
	Royalty: 'Autorský honorář',
	'PR contribution': 'PR příspěvek',
	Currency: 'Měna',
	Comment: 'Komentář',
	Paid: 'zaplaceno',
	Invoices: 'Faktury',
	Payer: 'Příjemce',
	'Payment order': 'Platební příkaz',
	Code: 'Kód',
	'Bank of the recipient': 'Banka příjemce',
	Acts: 'Acts',
	Scan: 'Skenování',
	'Period report': 'Hlášení období',
	City: 'Město',
	'Full name franchise': 'jméno a příjmení franšízy',
	'Students active': 'Žáci jsou aktivní',
	'Сost of education': 'Náklady na vzdělání',
	'Turnover franchise': 'Franchisový obrat ',
	'Discount sum': 'Výše slevy',
	Proprietor: 'royality',
	'Additional products and services': 'doplňkové produkty a služby',
	'Full name student': 'jméno a příjmení žaka',
	'Period of study': 'Doba studia',
	'Bonus-days': 'Bonusové dny',
	'The beginning of the holidays': 'Začátek prázdnin',
	'Amount of days': 'Počet dní',
	'Total days': 'celkový počet dní',
	'Language of instruction': 'jazyk výuky',
	Teacher: 'Učitel',
	Discount: 'Sleva',
	Remuneration: 'Odměna',
	Goods: 'Zboží',
	'Date of creation': 'Datum vytvoření',
	'Date of payment': 'Datum platby',
	'Goods (works, services)': 'Zboží (práce, služby)',
	Quantity: ' Množství ',
	Units: ' Jednotky ',
	Amount: 'Součet',
	Sum: 'Částka',
	Financial: 'Finanční',
	Additional: 'Dodatečný',
	General: 'Všeobecná',
	Total: 'Celkem',
	Save: 'Uložit',
	'Including with': 'Včetně s',
	'Training materials': 'školicí materiály',
	'Learning contract': 'Smlouva o studiu',
	Games: 'Hry',
	'NUMBER OF 11 TO 120': 'ČÍSLA OD 11 DO 120',
	Complexity: 'Obtížnost',
	Start: 'Start',
	'Speedy numbers': 'Rychlé a zběsilé',
	Anzan: 'Anzan',
	'Abacus is random': 'Náhodný Abakus ',
	Multiplication: 'Násobení',
	Division: 'Dělení',
	Abacus: 'Abakus',
	'Multiplying by 20': 'násobení do 20',
	Squared: 'doplnění na čtverec',
	'Division to 20': 'DĚLENÍ DO 20',
	Speed: 'Rychlost',
	Repeat: 'Opakovat', //'Počet výrazů',
	'Game type': 'Druh hry',
	'Digit type': 'Typ čísel',
	Digit: 'Číslo',
	Time: 'Čas',
	Second: 'Sekund',
	Level: 'Úroveň',
	'Action with numbers': 'množství akcí',
	'Action with number': 'množství akcí',
	'Number of expressions': 'množství výrazů',
	'Number of expression': 'množství výrazů',
	'Imaginary abacus': 'Imaginární Abakus',
	'Calculation method': 'Metoda výpočtu',
	'Only negative numbers starting with 99,999,9999 etc., depending on the complexity of the expression: -9, -2, -3, -1 ...':
		'Pouze záporná čísla, počínaje 99 999 9999 atd., v závislosti na složitosti výrazu: -9, -2, -3, -1...',
	'Only subtraction': 'Pouze odčítání',
	'Only positive numbers starting with 0. Expression: +1, +4, +6, +9, +5 ...':
		'Pouze kladná čísla začínající od 0. Výraz: +1, +4, +6, +9, +5 ...',
	'Only add': 'Pouze přidat',
	'Numbers fall randomly, starting with 0. Expression :: +3, -5, -1, +9, -2 ...':
		'Čísla jsou náhodně generována od 0. Výraz:: +3, -5, -1, +9, - 2 ...',
	'Random numbers': 'Náhodná čísla',
	'CHOOSE COMPLEXITY:': 'ZVOLTE OBTÍŽNOST:',
	'AMOUNT OF ACTIONS WITH NUMBER': 'POČET AKCÍ S ČÍSLY',
	FAMILY: 'RODINA',
	'BIG FRIENDS': 'VELKÉ PŘÁTELÉ',
	'LITTLE FRIENDS': 'MALÉ PŘÁTELÉ',
	'JUST FRIENDS': 'JEN PŘÁTELÉ',
	family: 'rodina',
	'big friends': 'VELKÉ PŘÁTELÉ',
	'small friends': 'malí přátelé',
	elementary: 'jen přátelé',
	Sound: 'Zvuk',
	Loading: 'Načítá se',
	back: 'zpátky',
	Back: 'zpátky',
	Add: 'Přidat',
	'Add file': 'Přidat soubor',
	ANSWER: 'Odpověď',
	'Congratulations! You did it! Now you can go to the following exercises':
		'Gratulujeme! Udělal jsi to! Nyní můžete přistoupit k následujícím cvičením',
	'RIGHT. ANSWER:': 'SPRÁVNĚ. ODPOVĚĎ:',
	CORRECT: 'SPRÁVNĚ',
	'NOT CORRECT': 'NESPRÁVNÉ',
	'Try again': 'zkusit znovu',
	expression: 'výraz',
	Lesson: 'Lekce',
	Oral: 'ústní počet',
	'History statistics': 'Historie statistiky',
	Open: 'Otevřít',
	'Game statistics per day': 'Herní statistiky pro tento den',
	'Total played games': 'Celkový počet odehraných her',
	'Total correct answers': 'Celkem správných odpovědí',
	'Total played:': 'Celkem odehráno:',
	Feedback: 'Zpětná vazba',
	'Leave a review': 'Zanechat recenzi',
	'Leave us your feedback or wishes and we will definitely consider them in our work.':
		'Zanechte nám svůj názor nebo přání a my je při naší práci určitě zohledníme',
	next: 'následující',
	Next: 'Další',
	Previous: 'Předchozí',
	'Payment history': 'Historie plateb',
	'Payment status': 'Status platby',
	Pay: 'Zaplatit',
	'Getting a discount': 'Získat slevu',
	Training: 'Výcvik',

	'Online abacus': 'Online Abakus ',
	'Base 50/100': 'Základ 50/100',
	multiply_base: 'База 50/100',
	divided: 'rozdělené',
	'Do not show this instruction again': 'Nezobrazovat tento pokyn znovu',
	'Instructions for homework': 'Pokyny pro domácí úkol',
	divider: 'dělič',
	'Multiplication table': 'Násobící tabulka',
	Restore: 'Obnovit',
	Left: 'Zbývá',
	New: 'Nový',
	'Restore Hierarchy': 'Obnovit hierarchii',
	total: 'celkem',
	active: 'aktivních',
	blocked: 'blokováno',
	pageError: {
		'403': 'Přístup je zamítnut.',
		'404': 'Tato stránka neexistuje. Zkuste to znovu.',
		'500': 'Server neodpovídá. Zkuste to znovu.',
	},
	error: {
		'Account deactivated': 'Váš účet byl deaktivován',
	},
	modalNewVersion: {
		text: 'Používáte zastaralou verzi webu.\nNyní je k dispozici aktualizace.',
		btn: 'aktualizovat',
	},
	games: {
		negativeNumbers: 'Záporná čísla',
		pause: 'Přestávka',
		resume: 'Pokračovat',

		columns: {
			name: 'sloupce',
			users: 'Počet hráčů',
			user: 'Hráč',
			userNames: 'Jména hráčů',
		},
	},
	'Indigo-dollars': 'Indigo-dolary',
	Balance: 'Balance',

	modalIndigoDollars: {
		submit: 'Odeslat',
		cancel: 'Zrušit',
		title: 'Indigo-dolary',
		balance: 'Aktuální balance ',
		amount: 'množství',
		reason: 'Komentář',
	},

	modalAddNotification: {
		title: 'Přidat zprávu ',
		submit: 'Odeslat',
		cancel: 'Zrušit',
		empty: 'Žádné zprávy',
	},

	modalTransactionsHistory: {
		title: 'Historie plateb',
		type: {
			withdraw: 'odepisování',
			deposit: 'deposit',
		},
		empty: 'Seznam plateb je prázdný',
	},

	modalCopyHomework: {
		title: 'Kopírovat domácí úkol',
		label: 'Vyberte datum, do kterého chcete zkopírovat domácí úkol',
		submit: 'Kopírovat',
		cancel: 'Zrušit',
	},

	reportsPage: {
		history: {
			title: 'Historie změn',
			empty: 'Seznam je prázdný',
			table: {
				date: 'datum změny',
				field_name: 'Akce', //'Název mezery'
				old_value: 'starý význam',
				new_value: 'nový význam',
				user: 'Změněno u uživatele',
			},
		},
	},

	pageShop: {
		title: 'Obchod',
		description:
			'V obchodě si můžete zakoupit různé produkty pro zlepšení vizuálního vzhledu vašeho osobního kabinetu.',

		tabs: {
			all: 'všechno zboží',
			purchased: 'Zakoupeno',
		},

		item: {
			off_all: 'Ne',

			status: {
				AVAILABLE: 'K dispozici',
				DEPRECATED: 'Nedostupné',
				COMING_SOON: 'brzy',
			},
			is_activated: 'Zvolen',
			set_active: 'Vybrat',
			unset_active: 'Deaktivovat',
			preview: 'Podívat se',
			is_free: 'Bezplatná',
			buy: 'Koupit',
			bought: 'Zakoupeno',
			purchased: 'Zakoupeno',
		},
		empty: {
			all: 'Žádné produkty nejsou k dispozici',
			purchased: 'Žádné zakoupené položky',
		},

		toast: {
			error: 'Vyskytla se chyba',
			notEnoughMoney: 'Nedostatek finančních prostředků',
			itemBought: 'Vylepšení zakoupeno',
			itemActivated: 'Vylepšení aktivováno',
			itemDeactivated: 'Vylepšení deaktivovano',
		},
		confirmPurchase: {
			title: 'Potvrdit nákup',
			message: 'Opravdu chcete koupit tuto položku?',
			confirm: 'Ano, koupit',
			cancel: 'Zrušit',
		},
	},

	demo: {
		title: 'Bezplatná ukázková lekce',
		tutorial: {
			title: 'Návod',
			text:
				'Gratulujeme, vstoupili jste do online světa mentální aritmetiky Indigo Mental. Indigo Mental - je to nejlepší mentální aritmetická škola na světě, dlouholeté zkušenosti společnosti a úspěchy mnoha studentů po celém světě na olympiádách dokazují, že tato metoda je účinná a jedinečná.spousta rodičů jsou již dlouho přesvědčeni o účinnosti metody a radují se z úspěchů svých dětí nejen v aritmetice, ale i v jiných vědách, hudbě, sportu a zaznamenávají velký skok v intelektových schopnostech svého dítěte.\n Mentální aritmetika je japonská metoda rychlého ústního počítání, která rychle rozvíjí mentální schopnosti a intelekt dítěte. Proces učení probíhá na speciálních japonských počitadlách Abakus(Soroban).Mentální aritmetika současně trénuje levou a pravou hemisféru mozku, zlepšuje zrakovou paměť, koncentraci, kreativní zaměření a nápadité myšlení dětí.\nZačněme se učit mentální aritmetiku, pro tento účel klikněte na tlačítko "PLAY" na videu níže, poslouchejte a opakujte.',
		},
	},

	disableStudent: {
		btn: 'Odpojit žaka',
		list: 'žaci bez data deaktivace',
		modal: {
			title: 'Odpojení žaka ',
			description: 'Chystáte se odpojit žaka',
			fieldLabel: 'Vyberte měsíc',
			btnSubmit: 'Deaktivovat',
			btnCancel: 'Zrušit',
		},
	},
}
